import { useEffect, useState } from "react";
import { useLanguage } from "../../../../stores/LanguageStore";
import { getAIKeys } from "../../../../api/ConfigsApi";
import { useConfigStore } from "../../../../stores/ConfigStore";
import {
  Anchor,
  Button,
  Group,
  LoadingOverlay,
  Select,
  Text,
  Title,
} from "@mantine/core";
import { validateOvhApi } from "../../../../api/ovh";
import OvhNoKey from "./OvhNoKey";
import OvhKeyValidation from "./OvhKeyValidation";
import { IconArrowRight, IconKey } from "@tabler/icons-react";
import { Link } from "react-router-dom";
import { useSessionStore } from "../../../../stores/UserStore";

const OvhStep1 = ({ setActiveStep, apiKey, setApiKey }) => {
  const lang = useLanguage((s) => s.language);
  const keys = useConfigStore((s) => s.externalKeys);
  const [loading, setLoading] = useState(true);
  const [validating, setValidating] = useState(false);
  const [validated, setValidated] = useState(false);

  const onNewKeyCreated = (new_key_id) => {
    setLoading(true);
    setApiKey(new_key_id.toString());
  };

  useEffect(() => {
    if (apiKey) {
      setValidating(true);
      validateOvhApi({ external_api_key_id: apiKey })
        .then((res) => {
          setValidated(true);
        })
        .catch((err) => {
          setValidated(false);
        })
        .finally(() => setValidating(false));
    }
  }, [apiKey]);

  const handleNext = () => {
    setActiveStep(1);
  };

  useEffect(() => {
    if (loading) {
      getAIKeys().finally(() => setLoading(false));
    }
  }, [loading]);

  return (
    <>
      <Title order={2}>{lang.ovh.step1.title}</Title>
      <Text size="md">{lang.ovh.step1.text.replace(
          "#",
          useSessionStore.getState().reseller?.name
        )}</Text>

      <Text>
        {lang.ovh.step1.text1}{" "}
        <Anchor
          href="https://www.ovh.com/auth/api/createToken"
          target="_blank"
          fw={600}
        >
          {" "}
          {lang.ovh.step1.text1_link}{" "}
        </Anchor>
      </Text>

      {loading ? (
        <LoadingOverlay visible />
      ) : keys.filter((x) => x.type === "ovh").length === 0 ? (
        <OvhNoKey onFinish={onNewKeyCreated} />
      ) : (
        <Select
          id="api_key"
          label={lang.ovh.step1.select_label}
          required
          placeholder={lang.ovh.step1.select_placeholder}
          data={keys
            .filter((x) => x.type === "ovh")
            .map((item) => ({
              label: item.name,
              value: item.id.toString(),
            }))}
          value={apiKey}
          onChange={setApiKey}
          comboboxProps={{ zIndex: 1600 }}
          size="lg"
        />
      )}
      <OvhKeyValidation
        validated={validated}
        validating={validating}
        apiKey={apiKey}
        hasApiKey={keys.filter((x) => x.type === "ovh").length > 0}
      />

      <Group mt={"auto"} justify="space-between">
        {keys.length && (
          <Button
            component={Link}
            to={"/settings/integrations/main"}
            leftSection={<IconKey />}
            size="md"
            w={300}
            variant="light"
          >
            {lang.ovh.step1.button_label}
          </Button>
        )}
        {validated && apiKey && !validating && (
          <Button
            rightSection={<IconArrowRight />}
            size="md"
            w={300}
            onClick={handleNext}
          >
            {lang.ovh.continue}
          </Button>
        )}
      </Group>
    </>
  );
};

export default OvhStep1;
